import { defineMessages } from 'react-intl';

export const messages: {
	atlassianSupport: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	freeGuestAccess: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	pageInsights: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	pagePermissions: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	rovo: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	unlimitedAutomation: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	unlimitedUsers: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	userPermissions: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	whiteboards: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	unlimitedUsers: {
		id: 'recommend-standard-over-premium.feature-name-column.unlimited-users',
		defaultMessage: 'Unlimited users',
		description: 'The name of a feature available in a paid edition of Jira or Confluence.',
	},
	pagePermissions: {
		id: 'recommend-standard-over-premium.feature-name-column.page-permissions',
		defaultMessage: 'Page permissions',
		description: 'The name of a feature available in a paid edition of Confluence.',
	},
	userPermissions: {
		id: 'recommend-standard-over-premium.feature-name-column.user-permissions',
		defaultMessage: 'User permissions',
		description: 'The name of a feature available in a paid edition of Jira.',
	},
	freeGuestAccess: {
		id: 'recommend-standard-over-premium.feature-name-column.free-guest-access',
		defaultMessage: 'Free guest access',
		description: 'The name of a feature available in a paid edition of Jira or Confluence.',
	},
	pageInsights: {
		id: 'recommend-standard-over-premium.feature-name-column.page-insights',
		defaultMessage: 'Page insights',
		description: 'The name of a feature available in a paid edition of Confluence.',
	},
	atlassianSupport: {
		id: 'recommend-standard-over-premium.feature-name-column.atlassian-support',
		defaultMessage: 'Atlassian support',
		description: 'The name of a feature available in a paid edition of Jira.',
	},
	rovo: {
		id: 'recommend-standard-over-premium.feature-name-column.rovo',
		defaultMessage: 'Rovo AI',
		description: 'The name of a feature available in a paid edition of Confluence and Jira.',
	},
	unlimitedAutomation: {
		id: 'recommend-standard-over-premium.feature-name-column.unlimited-automation',
		defaultMessage: 'Unlimited automation',
		description: 'The name of a feature available in a paid edition of Jira.',
	},
	whiteboards: {
		id: 'recommend-standard-over-premium.feature-name-column.whiteboards',
		defaultMessage: 'Whiteboards',
		description: 'The name of a feature available in paid editions of Confluence and Jira.',
	},
});
